module.exports = __webpack_public_path__ + "static/Gotham-Thin-38253acbc465686740b427fabd482909.ttf";